module.exports = __webpack_public_path__ + "static/media/disabled-eye.afd8bf88.jpg";